<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>ពាក្យសំងាត់ចាស់</label>
										<md-input type="password" v-model="old_password" />
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>ពាក្យសំងាត់ថ្មី</label>
										<md-input type="password" v-model="new_password" />
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>បញ្ជាក់ពាក្យសំងាត់ថ្មី</label>
										<md-input type="password" v-model="confirm_password" />
									</md-field>
								</div>
								<div class="md-layout-item md-size-100 text-right">
									<md-button class="md-raised md-primary" @click="changePassword()">ផ្លាស់ប្តូរ</md-button>
								</div>
							</div>

						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				old_password: "",
				new_password: "",
				confirm_password: ""
			}
		},
		methods: {
			changePassword() {
				if (this.checkValidation()) {
					this.$http.post(this.config.api + "/admin/driver/change_password", {
						old_password: this.old_password,
						new_password: this.new_password,
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "ពាក្យសំងាត់បានផ្លាស់ប្តូរដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.$router.push('/dashboard');
						}
					})
				}
			},
			checkValidation() {
				if (String(this.old_password).length > 5 && String(this.new_password).length > 5 && String(this.new_password) == String(this.confirm_password)) {
					return true;
				} else {
					if (String(this.old_password).length == 0 || String(this.new_password).length == 0 || String(this.confirm_password).length == 0) {
						this.$notification.notify({
							message: "សូមបំពេញព័ត៌មាន។",
							icon: 'error',
							type: 'danger'
						})
					} else if (this.new_password.length < 6) {
						this.$notification.notify({
							message: "ពាក្យសំងាត់ថ្មីត្រូវមានអក្សរចាប់ពី ៦តួរឡើង។",
							icon: 'error',
							type: 'danger'
						})
					} else if (this.new_password != this.confirm_password) {
						this.$notification.notify({
							message: "បញ្ជាក់ពាក្យសំងាត់ថ្មីមិនត្រឹមត្រូវ។",
							icon: 'error',
							type: 'danger'
						})
					}
					return false;
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Settings.vue